import { render, staticRenderFns } from "./ViajesPersonalizados.vue?vue&type=template&id=33808757"
import script from "./ViajesPersonalizados.vue?vue&type=script&lang=js"
export * from "./ViajesPersonalizados.vue?vue&type=script&lang=js"
import style0 from "./ViajesPersonalizados.vue?vue&type=style&index=0&id=33808757&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports